import { ClientClaim, IUserInfo } from 'gen/ApiClient';

export const calculateUserHasClientClaim = (user: IUserInfo, clientClaim: ClientClaim): boolean => {
	if (user.clientClaims === undefined || user.clientClaims === null || user.clientClaims.length === 0) {
		return false;
	} else {
		return user.clientClaims.indexOf(clientClaim as ClientClaim) > -1;
	}
};
